<template>
<swiper class="swiper" ref="mySwiper" :options="swiperOptions">
    <swiper-slide>
      <div class="item">
        <h1 class="main-title">企业金融解决方案</h1>
        <div class="sub-title">
          金融机构科技战略伙伴
        </div>
        <router-link to="/solutionDetails2" class="try-button">了解详情</router-link>
        <div class="foot-title">
          <p class="zh" s18n="">探索科技的无限可能</p>
          <p class="en">Explore the possibilities of technology</p>
        </div>
        <img src="@/assets/img/banner-01.jpg">
      </div>
    </swiper-slide>
    <swiper-slide>
      <div class="item">
        <h1 class="main-title">汽车金融解决方案</h1>
        <div class="sub-title">
          定制化的汽车行业服务方案，满足客户的多样服务需求
        </div>
        <router-link to="/afSolutionDetails" class="try-button">了解详情</router-link>
        <div class="foot-title">
          <p class="zh" s18n="">探索科技的无限可能</p>
          <p class="en">Explore the possibilities of technology</p>
        </div>
        <img src="@/assets/img/banner-02.jpg">
      </div>
    </swiper-slide>
    <swiper-slide>
      <div class="item">
        <h1 class="main-title">智能终端测试解决方案</h1>
        <div class="sub-title">
          用数据智能为您的业务加速
        </div>
        <router-link to="/solutionDetails6" class="try-button">了解详情</router-link>
        <div class="foot-title">
          <p class="zh" s18n="">探索科技的无限可能</p>
          <p class="en">Explore the possibilities of technology</p>
        </div>
        <img src="@/assets/img/banner-03.jpg">
      </div>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: '',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
        swiperOptions: {
          loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination',
            dynamicBullets: true,
            dynamicMainBullets: 2
          },
           navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        }
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      }
    },
    mounted() {
      console.log('Current Swiper instance object', this.swiper)
      // this.swiper.slideTo(1, 1000, false)
    },
  directives: {
    swiper: directive
  }
}
</script>

<style scoped lang="less">
.swiper{
  margin-top: 72px;
}
.item{
  position: relative;
  img{ 
    width: 100%;
    vertical-align: middle;
  }
  .main-title{
    position: absolute;
    left: 50%;
    width: 100%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    top: 100px;
    font-size: 6.43em;
    font-weight: 700;
    color: #fff;
    letter-spacing: 9px;
    text-align: center;
    margin: 0;
    text-shadow: 0 2px 23px rgba(8,19,29,.77);
  }
  .sub-title {
    position: absolute;
    left: 50%;
    width: 100%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    top: 250px;
    font-size: 2.85em;
    color: #fff;
    letter-spacing: 2.67px;
    text-align: center;
    line-height: 50px;
    text-shadow: 0 2px 23px rgba(8,19,29,.77);
    margin: 1% 0 3.34%;
  }
  .try-button{
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    top: 380px;
    display: block;
    cursor: pointer;
    border: 2px solid #fff;
    border-radius: 4px;
    width: 200px;
    line-height: 50px;
    margin: 0 auto;
    font-size: 18px;
    color: #fff;
    letter-spacing: 1px;
    text-align: center;
    background: 0 0;
    text-decoration: none;
  }
  .foot-title{
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    bottom: 82px;
    .zh {
      font-size: 18px;
      color: #fff;
      text-align: center;
      letter-spacing: 6.34px;
      line-height: 24px;
    }
    .en {
      font-size: 14px;
      color: #fff;
      text-align: center;
      letter-spacing: .32px;
      text-shadow: 0 0 4px rgba(0,0,0,.32);
    }
  }
  
}
</style>
